import { Key, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Link, Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';

import { AuthContext, useAuth } from 'context/AuthContext';

import ArticlePlaceholder from 'components/ui/article-placeholder';

import Box from 'components/ui/box';
import {
  getDeletedTasks,
  getPartialTask,
  getPlayerInfo,
  getServerTime,
  getTasks,
  getTotalTasks,
} from 'services/dashboard.service';
import { TaskItem } from 'components/task-item';

import ImgFeedback from 'assets/img/comportamento/bg-missoes-not-found.png';
import Button from 'components/ui/button';
import { IoIosArrowBack, IoIosArrowForward, IoIosWarning } from 'react-icons/io';
import { BsPlusLg } from 'react-icons/bs';
import { BiMinus } from 'react-icons/bi';
import Tippy from '@tippyjs/react';
import CustomSelect from 'components/custom-select';
import { subMinutes } from 'date-fns';
import { format } from 'date-fns-tz';
import { NotFound } from 'pages/NotFound';
import { GetVersion } from 'services/utils';
import ModalChangeIndicator from 'components/modal-change-indicator';
import { getFutureCalendar } from 'utils/helpers';
import ModalSendMessage from 'components/modal-send-message';
import { PHASE_WITHOUT_REALIZATIONS_ID, resolveEmptyState } from './empty-state';
import { DeletedTasksResult, loadDeletedTasks, resolveDeletedSection } from './deleted-tasks';
import { DeletedTasksSection } from './deleted-tasks-section';

// const cycles = [new Date('2022-11-18'), new Date('2022-12-18')];
// const cyclesStatus = ['PERÍODO DE AVALIAÇÃO', 'ENVIAR ENTREGAS'];
// const currentCycle = 1;

export default function MissaoDestaque() {
  const { user, cyclesExtended, realCycle, cycleSelected, setCycleSelected } = useAuth();
  const navigate = useNavigate();

  const [realDatetime, setRealDatetime] = useState<number>(0);

  const [playerInfo, setPlayerInfo] = useState<any>();
  const [isGestor, setIsGestor] = useState<boolean | undefined>();
  const [totalTasks, setTotalTasks] = useState<{ total: number; total_participation: number; can_register: boolean }>({
    total: 0,
    total_participation: 0,
    can_register: false,
  });
  const [loading, setLoading] = useState(true);
  const [myTasks, setMyTasks] = useState<any[]>();
  const [otherTasks, setOtherTasks] = useState<any[]>();
  const [allTasks, setAllTasks] = useState<any[]>();
  const [deletedTasks, setDeletedTasks] = useState<DeletedTasksResult>();

  const [stages, setStages] = useState<any>();
  const [taskCyclesAll, setTaskCyclesAll] = useState<any>();

  const [tab, setTab] = useState<'cadastrada' | 'participando'>('cadastrada');
  const [cycleActive, setCycleActive] = useState<string>();
  const [elementsIndexOf, setElementsIndexOf] = useState<number>();
  const [numberOfElements, setNumberOfElements] = useState(3);
  const [showMore, setShowMore] = useState(false);
  const [calendarElementsIndexOf, setCalendarElementsIndexOf] = useState<number>(5);
  const [calendarNumberOfElements, setCalendarNumberOfElements] = useState(5);
  const [calendarShowMore, setCalendarShowMore] = useState(false);
  const [optionsCycle, setOptionsCycle] = useState<any[] | undefined>([]);
  const [activeItem, setActiveItem] = useState<any>();
  const [showModal, setShowModal] = useState<{ id: string; owner?: string } | undefined>();
  const [onOpenModalSendMessage, setOnOpenModalSendMessage] = useState<
    { managerName: string; participantCount: number; taskTitle: string; managerId: string } | boolean
  >(false);
  const [hasPartialTask, setHasPartialTask] = useState<boolean>(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const faseParam = searchParams.get('fase');

  const [faseUrl, setFaseUrl] = useState(faseParam || '');

  function handleClickCreate() {
    navigate('./cadastrar');
  }

  useEffect(() => {
    let interv: any = undefined;

    getServerTime().then(timestamp => {
      setRealDatetime(timestamp);

      interv = window.setInterval(() => {
        setRealDatetime(prevstate => prevstate + 1000);
      }, 1000);
    });

    return () => clearInterval(interv);
  }, []);

  const activeStageObj = useMemo(() => {
    // if (cycleActive === 'semestral') {
    //   const cycle = realCycle?.find(x => x._id === cycleSelected?._id);

    //   const evaluationStage = stages.find((x: any) => x.status === 'open' || x.status === 'evaluation') || stages[0];
    //   if (!evaluationStage || !cycle?.date_start || !cycle?.date_end) return undefined;

    //   const _stages = {
    //     ...evaluationStage,
    //     title: 'Semestral',
    //     date_start: cycle?.date_start,
    //     date_finish: cycle?.date_end,
    //     step: 5,
    //     // taskStep >= 5 getTaskStep
    //   };

    //   return _stages;
    // }

    // if (cycleActive === 'trimestral') {
    //   const evaluationStage = stages.find((x: any) => x.status === 'open' || x.status === 'evaluation') || stages[0];
    //   if (!evaluationStage || !evaluationStage?.date_trimester_start || !evaluationStage?.date_trimester_finish) return undefined;

    //   const _stages = {
    //     ...evaluationStage,
    //     title: 'Trimestral',
    //     date_start: evaluationStage?.date_trimester_start,
    //     date_finish: evaluationStage?.date_trimester_finish,
    //     step: 4,
    //     // taskStep >= 4 getTaskStep
    //   };

    //   return _stages;
    // }

    return stages?.find((item: any) => item._id === cycleActive);
  }, [cycleActive, stages]);

  const tasksPerCycle: any = useMemo(() => {
    if (!Array.isArray(myTasks) || !Array.isArray(otherTasks) || !stages?.length || !cycleActive) return null;

    const tasks = [...(tab === 'cadastrada' ? myTasks : otherTasks)];

    return tasks?.length ? tasks : [];
  }, [cycleActive, myTasks, otherTasks, tab, stages]);

  const resumePerCycle: {
    registered: number;
    validated: number;
    waiting: number;
  } | null = useMemo(() => {
    if (!Array.isArray(myTasks) || !Array.isArray(otherTasks) || !stages?.length || !cycleActive) return null;

    const cycle = stages.find((cycle: any) => cycle._id === cycleActive);
    const tasks = [...(tab === 'cadastrada' ? myTasks : otherTasks)]?.filter(
      item => item.created >= cycle?.date_start && item?.created <= cycle?.date_finish,
    );

    return {
      registered: tasks.length || 0,
      validated: tasks?.filter(task => !!task.status?.match(/(aprovado|dobrado|promovido|selo|concluido)/gi))?.length || 0,
      waiting: tasks?.filter(task => !!task.status?.match(/(aguardando)/gi))?.length || 0,
    };
  }, [cycleActive, myTasks, otherTasks, tab, stages]);

  const getActiveEvaluationStep: 0 | 2 | 3 | 4 | 4.1 | 5 | null = useMemo((): 0 | 2 | 3 | 4 | 4.1 | 5 | null => {
    if (!activeStageObj || !realDatetime) return null;

    if (realDatetime > activeStageObj.date_evaluation_step2_start && realDatetime < activeStageObj.date_evaluation_step2_finish) {
      // Etapa 2 - Validação, Nível 1 e Nível 2 Bonificação MAD
      return 2;
    } else if (
      realDatetime > activeStageObj.date_evaluation_step3_start &&
      realDatetime < activeStageObj.date_evaluation_step3_finish
    ) {
      // Etapa 3
      return 3;
    } else if (
      realDatetime > activeStageObj.date_evaluation_step4_start &&
      realDatetime < activeStageObj.date_evaluation_step4_finish
    ) {
      // Etapa 4 - Nível 2 e pit stop
      return 4;
    } else if (
      realDatetime > activeStageObj.date_evaluation_pitStop_start &&
      realDatetime < activeStageObj.date_evaluation_pitStop_finish
    ) {
      // Pit Stop
      return 4.1;
    } else if (
      realDatetime > activeStageObj.date_evaluation_step5_start &&
      realDatetime < activeStageObj.date_evaluation_step5_finish
    ) {
      // Etapa 5 - Nível 3
      return 5;
    } else {
      return 0;
    }
  }, [activeStageObj, realDatetime]);

  const getFullCalendar = useMemo(() => {
    if (!cyclesExtended || !cycleSelected) return null;

    const cycleActive = cyclesExtended.find(x => x._id === cycleSelected?._id);

    if (cycleActive) {
      const calendar = getFutureCalendar(cycleActive?.steps, realDatetime);
      return calendar;
    }

    return null;
  }, [cycleSelected, cyclesExtended, realDatetime]);

  const taskEditable = useCallback(
    (task: any): boolean => {
      if (!activeStageObj || !user) return false;

      if (
        tab === 'cadastrada' &&
        task.owner === user._id &&
        task.created >= activeStageObj.date_start &&
        task.created <= activeStageObj.date_finish
      ) {
        if (task.status === 'aguardando' && activeStageObj.status === 'open') {
          return true;
        }

        if (task.status === 'rejeitado' && getActiveEvaluationStep && getActiveEvaluationStep === 2) {
          return true;
        }

        return false;
      }

      return false;
    },
    [activeStageObj, getActiveEvaluationStep, tab, user],
  );

  const taskCanUpdateIndicator = useCallback(
    (task: any): boolean => {
      if (!activeStageObj || !user || activeStageObj.date_start < 1743822000000) return false;

      if (tab === 'cadastrada' && task.owner === user._id) {
        if (!task?.indicator) return true;

        if (task?.indicator?.cod === 1 || task?.indicator?.cod === '1') return true;

        return false;
      }

      return false;
    },
    [activeStageObj, tab, user],
  );

  // Quem exclui é o próprio cadastrante: o cabeçalho das excluídas usa os dados do usuário logado.
  const deletedOwner = {
    _id: user?._id ?? '',
    nomeGuerra: playerInfo?.nome_guerra ?? user?.name,
    avatar: { ...user, ...user?.extra },
  };

  function renderTasksPerCycle() {
    if (!resumePerCycle) return null;

    try {
      if (tasksPerCycle?.length) {
        return tasksPerCycle.map((task: { _id: Key | null | undefined; owner: string | undefined; status: string }) => (
          <div key={task._id}>
            <TaskItem
              data={task}
              editable={taskEditable(task)}
              canUpdateIndicator={taskCanUpdateIndicator(task)}
              onUpdateIndicator={() => {
                setShowModal({ id: String(task?._id || ''), owner: task.owner });
              }}
              onDelete={() => loadData()}
              onReload={() => loadData()}
              cycle={activeStageObj}
              playerInfo={playerInfo}
              onOpenModalSendMessage={param => setOnOpenModalSendMessage(param)}
            />
          </div>
        ));
      }
    } catch (e) {
      return null;
    }
  }

  function translate(total: number) {
    switch (total) {
      case 3:
        return 'três';
      case 2:
        return 'dois';
      default:
        return '';
    }
  }

  function renderCreateTaskPerCycle() {
    if (!resumePerCycle) return null;

    const estadoVazio = resolveEmptyState({ tab, myTasks, otherTasks, stage: activeStageObj });
    if (estadoVazio === 'nenhum') return null;

    // if (tab === 'cadastrada' && !totalTasks?.can_register && (!myTasks?.length || myTasks?.length < 1))
    //   return (
    //     <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center">
    //       <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
    //         <strong className="block text-center text-yellow font-semibold text-xl">
    //           {/* Você{activeStageObj?.status === 'open' ? ' ainda' : ''} não foi incluído em Ações ECOA de outros */}
    //           Você já foi incluído no número máximo de Realizações Destaque de outros colegas!
    //         </strong>
    //       </p>
    //     </div>
    //   );

    // Fase em apreciação, encerrada ou sem Realizações Destaque: sem convite para cadastrar, só o aviso.
    if (estadoVazio === 'fase-sem-realizacao') {
      return (
        <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center">
          <img src={ImgFeedback} className="max-w-[150px]" alt=" " />
          <p tabIndex={0} className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
            <strong className="block text-center text-yellow font-semibold text-xl">
              Não há Realizações Destaque nesta fase.
            </strong>
          </p>
        </div>
      );
    }

    return (
      <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center">
        <img src={ImgFeedback} className="max-w-[150px]" alt=" " />
        {tab === 'cadastrada' && (
          <>
            {activeStageObj?.type === 'month' ? (
              <>
                <p tabIndex={0} className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                  <strong className="block text-center text-yellow font-semibold text-xl">
                    Que tal cadastrar uma realização destaque nesta fase?
                  </strong>
                  Cadastre sua Realização Destaque, seja reconhecido pela liderança e ganhe recompensas! <br />
                  Lembre-se: você só pode cadastrar 1 realização neste mês (fase). <br />
                  <b>Atenção</b>: só devem ser cadastradas realizações <b>concluídas</b>.
                </p>
              </>
            ) : (
              <>
                <p tabIndex={0} className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                  <strong className="block text-center text-yellow font-semibold text-xl">
                    Não existem realizações apreciadas até o momento.
                  </strong>

                  {activeStageObj?.type === 'semester' && (
                    <span>As Realizações são apreciadas trimestralmente e enviadas para etapa de avaliação semestral.</span>
                  )}

                  {activeStageObj?.type === 'trimester' && (
                    <span>As Realizações são apreciadas mensalmente e enviadas para etapa de avaliação trimestral.</span>
                  )}
                </p>
              </>
            )}
          </>
        )}
        {tab === 'participando' && (
          <>
            {activeStageObj?.type === 'month' ? (
              <>
                <p tabIndex={0} className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                  <strong className="block text-center text-yellow font-semibold text-xl">
                    {/* Você{activeStageObj?.status === 'open' ? ' ainda' : ''} não foi incluído em Realizações Destaque de outros */}
                    Você ainda não foi incluído em Realizações Destaque de outros colegas!
                  </strong>
                  Caso tenha colaborado em alguma Realização de outra equipe, verifique com seus colegas a possibilidade de ser
                  indicado.
                </p>
              </>
            ) : (
              <>
                <p tabIndex={0} className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                  <strong className="block text-center text-yellow font-semibold text-xl">
                    Não existem realizações apreciadas até o momento.
                  </strong>

                  {activeStageObj?.type === 'semester' && (
                    <span>As Realizações são apreciadas trimestralmente e enviadas para etapa de avaliação semestral.</span>
                  )}

                  {activeStageObj?.type === 'trimester' && (
                    <span>As Realizações são apreciadas mensalmente e enviadas para etapa de avaliação trimestral.</span>
                  )}
                </p>
              </>
            )}
          </>
        )}

        {tab === 'cadastrada' &&
        user?.extra?.task !== false &&
        !playerInfo?.visualizador &&
        activeStageObj?.type &&
        activeStageObj?.type === 'month' ? (
          <div className="relative inline-block">
            <button
              className="text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded py-3 px-10"
              onClick={() => handleClickCreate()}
            >
              Cadastrar Realização Destaque
            </button>
            {!!hasPartialTask && (
              <Tippy content="Você possui uma realização em preenchimento. Clique no botão para continuar." placement="top">
                <div
                  className="absolute -top-3 -right-3 bg-yellow rounded-full p-1 cursor-pointer"
                  onClick={() => handleClickCreate()}
                  style={{
                    animation: 'partialTaskPulse 1.8s ease-in-out infinite',
                  }}
                >
                  <IoIosWarning size={18} className="text-oxford-blue" />
                </div>
              </Tippy>
            )}
            <style>{`
              @keyframes partialTaskPulse {
                0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(251, 253, 0, 0.4); }
                50% { transform: scale(1.1); box-shadow: 0 0 0 10px rgba(251, 253, 0, 0); }
                100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(251, 253, 0, 0); }
              }
            `}</style>
          </div>
        ) : null}
      </div>
    );
  }

  useEffect(() => {
    if (faseUrl && stages?.some((item: any) => item._id === faseUrl)) {
      setCycleActive(faseUrl);
      searchParams.delete('fase');

      setSearchParams(searchParams);
    } else if (stages?.length) {
      const currentCycle = stages?.find((item: any) => item.status === 'open' && item.type === 'month');
      const lastMonth = stages?.find((item: any) => item.type === 'month');
      setCycleActive(currentCycle?._id || lastMonth?._id || stages[0]._id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, stages, searchParams]);

  // useEffect(() => {
  //   console.log('tasksPerCycle', tasksPerCycle);
  //   console.log('resumePerCycle', resumePerCycle);
  // }, [tasksPerCycle, resumePerCycle]);

  async function loadData() {
    if (!cyclesExtended?.[0]) return;

    let playerInfoResult: any;
    if (!playerInfo) {
      playerInfoResult = await getPlayerInfo(user?._id);

      setPlayerInfo(playerInfoResult);
    } else {
      playerInfoResult = { ...playerInfo };
    }

    // const _totalTasks: any = await getTotalTasks();

    // setTotalTasks({
    //   total: _totalTasks?.total | 0,
    //   total_participation: _totalTasks?.total_participation | 0,
    //   can_register: _totalTasks?.can_register,
    // });

    // Gestor = quem tem etapa de apreciação (cod_etapa 1..5) própria ou de parceiro da
    // dupla. O cod_etapa_sub não conta (regra de 2026-10-21): o assessor cod 0 que
    // substitui um gestor continua cadastrando a própria realização aqui e aprecia só
    // pela lateralidade.
    const _isGestor =
      (!!playerInfoResult?.cod_etapa && playerInfoResult?.cod_etapa > 0 && playerInfoResult?.cod_etapa <= 5) ||
      (Array.isArray(playerInfoResult?.mad_dupla) &&
        playerInfoResult.mad_dupla.some(
          (md: any) => typeof md.cod_etapa === 'number' && md.cod_etapa > 0 && md.cod_etapa <= 5,
        ));
    setIsGestor(_isGestor);

    if (_isGestor) {
      setTab('participando');
    }

    const [data, deleted] = await Promise.all([
      getTasks(user?._id, activeStageObj.date_start, activeStageObj.date_finish, false, activeStageObj.step),
      loadDeletedTasks(activeStageObj, getDeletedTasks),
    ]);

    const my_tasks = data.filter((item: any) => item.owner === user?._id && item.status !== 'arquivado');
    const other_tasks = data.filter((item: any) => item.owner !== user?._id && item.status !== 'arquivado');

    setMyTasks(my_tasks);
    setOtherTasks(other_tasks);
    setAllTasks([...my_tasks, ...other_tasks]);
    setDeletedTasks(deleted);
    setLoading(false);
  }

  useEffect(() => {
    if (!cyclesExtended) return;

    const cycleOptions = cyclesExtended.map((cycle: any) => {
      cycle.label = 'Ciclo ' + cycle.title;
      cycle.value = cycle._id;

      return cycle;
    });

    setOptionsCycle(cycleOptions);

    if (!activeItem) {
      setActiveItem(cycleOptions.find(x => x.value === cycleSelected?._id) ? cycleSelected?._id : cycleOptions[0].value);
      setTaskCyclesAll(cyclesExtended.filter((item: any) => item.year > 2022));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cyclesExtended]);

  useEffect(() => {
    if (!user || !cyclesExtended || !stages || !activeStageObj) return;

    setLoading(true);

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, cyclesExtended, stages, activeStageObj]);

  useEffect(() => {
    if (!stages) return;

    if (stages.length <= numberOfElements) {
      setShowMore(false);
    } else {
      setShowMore(true);
    }
  }, [numberOfElements, stages]);

  useEffect(() => {
    if (!getFullCalendar) return;

    if (getFullCalendar.length <= calendarNumberOfElements) {
      setCalendarShowMore(false);
    } else {
      setCalendarShowMore(true);
    }
  }, [calendarNumberOfElements, getFullCalendar]);

  useEffect(() => {
    if (!activeItem) return;

    const filtredData = taskCyclesAll?.filter((item: any) => item._id === activeItem);

    if (!!filtredData?.length) {
      const _stages = filtredData[0].steps;
      const indexOf =
        (Array.isArray(_stages) && _stages?.map(x => x._id).indexOf(cycleActive as string) + 1 > 3
          ? _stages?.map(x => x._id).indexOf(cycleActive as string) + 1
          : 3) || 3;

      setElementsIndexOf(indexOf);
      setNumberOfElements(indexOf);

      setStages(filtredData[0].steps);
    }
  }, [activeItem, cycleActive, taskCyclesAll, stages]);

  useEffect(() => {
    if (!user || !cyclesExtended || !stages || !activeStageObj) return;

    async function loadPartialTask() {
      try {
        const partialTask = await getPartialTask();
        setHasPartialTask(!!partialTask?.team);
      } catch (error) {
        console.error('Erro ao carregar task parcial:', error);
      }
    }

    if (loading) loadPartialTask();

    document.addEventListener('reload:partialTask', loadPartialTask, false);

    return () => {
      document.removeEventListener('reload:partialTask', loadPartialTask);
    };
  }, [activeStageObj, cyclesExtended, stages, user, loading]);

  function getIndexByValue(array: any, value: string) {
    return array.findIndex((element: any) => element.value === value);
  }

  if (!user || typeof isGestor !== 'boolean') return null;

  // if (isGestor && !loading) {
  //   return (
  //     <div className="mx-auto container p-4 lg:p-10">
  //       <div className="flex flex-row items-center space-x-4 mb-16">
  //         <div>
  //           <Link to="../">
  //             <button className="rounded-full bg-purple flex justify-center items-center p-1">
  //               <RiArrowLeftSLine size={28} className="text-white" />
  //             </button>
  //           </Link>
  //         </div>
  //         <h1 className="text-xl lg:text-3xl text-white font-semibold">Realização Destaque</h1>
  //       </div>

  //       <div className="border-2 border-electric-blue rounded-3xl p-8 bg-oxford-blue">
  //         <p className="text-dandelion text-lg font-semibold block text-center">Você não possui acesso à esta página.</p>
  //       </div>
  //     </div>
  //   );
  // }

  if (user.extra.rede) return <NotFound />;

  return (
    <>
      <div className="mx-auto container p-4 lg:p-10">
        <div className="flex flex-row items-center space-x-4 mb-16">
          <div>
            <Link to="../" tabIndex={-1}>
              <button className="rounded-full bg-purple flex justify-center items-center p-1">
                <RiArrowLeftSLine size={28} className="text-white" />
              </button>
            </Link>
          </div>
          <h1 tabIndex={0} className="text-xl lg:text-3xl text-white font-semibold">Realização Destaque</h1>
        </div>

        <div className="border-2 border-electric-blue rounded-3xl p-8 mb-12 bg-oxford-blue">
          <p tabIndex={0} className="text-dandelion text-lg font-semibold block mb-3">Como funciona a dinâmica Realização Destaque?</p>
          <p tabIndex={0} className="text-white text-base font-light m-0">
            Essa dinâmica visa estimular a colaboração e valorizar a contribuição dos funcionários para o alcance dos diversos
            objetivos do Banco por meio da possibilidade de apreciação e reconhecimento de suas entregas pela liderança das
            unidades. <br />
            <br />
            Cadastre e descreva detalhadamente sua realização mais relevante do mês. Ela será apreciada pelos seus líderes e todos
            os participantes poderão receber pontos,
            <em className="italic">feedbacks</em> e <strong className="font-semibold">Selo Realização Destaque</strong>.
          </p>
        </div>

        <div className="rounded-xl overflow-hidden hidden lg:flex items-center justify-between mb-12">
          {!isGestor && (
            <button
              className={`${
                tab === 'cadastrada' ? 'bg-slate-blue' : 'bg-maastricht-blue'
              } w-6/12 h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-opacity`}
              onClick={() => (!loading ? setTab('cadastrada') : null)}
            >
              Realização Destaque cadastrada
            </button>
          )}
          <button
            className={`${tab === 'participando' ? 'bg-slate-blue' : 'bg-maastricht-blue'} ${
              isGestor ? 'w-full' : 'w-6/12'
            }  h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-opacity`}
            onClick={() => (!loading ? setTab('participando') : null)}
          >
            Participação em Realizações Destaque
          </button>
        </div>

        <div className="flex justify-between items-center lg:hidden mb-10">
          <Button
            color="clear"
            className="shadow-none pr-0 pl-0"
            disabled={tab === 'cadastrada'}
            onClick={() => setTab('cadastrada')}
          >
            <IoIosArrowBack className={`text-grey-dark ${tab === 'cadastrada' && 'opacity-5'}}`} size={24} />
          </Button>

          <p tabIndex={0} className="text-xl font-bold text-yellow">
            {tab === 'cadastrada' ? 'Realização Destaque cadastrada' : 'Participação em Realizações Destaque'}
          </p>

          <Button
            color="clear"
            className="shadow-none pr-0 pl-0"
            disabled={tab === 'participando'}
            onClick={() => setTab('participando')}
          >
            <IoIosArrowForward className={`text-grey-dark ${tab === 'participando' && 'opacity-5'}}`} size={24} />
          </Button>
        </div>

        <div className="w-full flex flex-col lg:flex-row lg:justify-between">
          <div className="lg:w-[32.5%]">
            <div className="mb-5">
              <h2 tabIndex={0} className="text-xl text-white block mb-6 font-semibold">Histórico de Realizações Destaque</h2>

              <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                {loading ? (
                  <div className="grid grid-cols-1 gap-3">
                    <ArticlePlaceholder />
                  </div>
                ) : (
                  <>
                    <div className="px-8 mb-8">
                      <div>
                        <p tabIndex={0} className="mb-2">Escolha o ciclo que deseja acompanhar</p>

                        {optionsCycle && (
                          <div className="mb-4">
                            <CustomSelect
                              placeholder="Clique para selecionar o ciclo"
                              options={optionsCycle}
                              onChange={(e: any) => {
                                setActiveItem(e.value);

                                const selected = cyclesExtended?.find(x => x._id === e.value);

                                if (selected) {
                                  setCycleSelected({
                                    _id: selected._id,
                                    title: selected.title,
                                    version: GetVersion(selected.date_start),
                                  });
                                }
                              }}
                              value={
                                optionsCycle.find(x => x.value === cycleSelected?._id)
                                  ? optionsCycle.find(x => x.value === cycleSelected?._id)
                                  : optionsCycle[getIndexByValue(optionsCycle, activeItem)]
                              }
                            />
                          </div>
                        )}
                      </div>

                      <p tabIndex={0} className="text-white mb-8 text-base font-normal block">Escolha a fase</p>

                      <ul className="space-y-4 flex flex-col">
                        {stages &&
                          stages.slice(0, numberOfElements).map((cycle: any) => (
                            <li key={cycle._id}>
                              <button
                                className={`${
                                  cycleActive === cycle._id ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                                onClick={() => setCycleActive(cycle._id)}
                              >
                                {cycle.title}
                                {/* {GetTaskStatusLabel(cycle.status)} */}
                              </button>
                            </li>
                          ))}

                        {!!stages && stages?.length > (elementsIndexOf as number) && (
                          <button
                            className="mt-4 mx-auto flex items-center text-grey-light justify-center lg:justify-start"
                            onClick={() =>
                              !showMore
                                ? setNumberOfElements(elementsIndexOf as number)
                                : setNumberOfElements(numberOfElements + 3)
                            }
                          >
                            {!showMore ? (
                              <>
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                                <span className="uppercase">Ver menos</span>
                              </>
                            ) : (
                              <>
                                <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                <span className="uppercase">Ver mais</span>
                              </>
                            )}
                          </button>
                        )}
                      </ul>
                    </div>

                    {activeStageObj?._id !== PHASE_WITHOUT_REALIZATIONS_ID && (
                      <div className="bg-maastricht-blue rounded-3xl p-8">
                        <p tabIndex={0} className="block text-white leading-none font-normal text-base mb-4">
                          Realizações Destaque de {activeStageObj?.title}
                        </p>

                        <ul className="flex flex-col w-full">
                          <li tabIndex={0} className="flex items-center justify-between text-white font-light text-xs leading-none mb-4 pb-4 border-b border-prussian-blue-2">
                            {tab === 'cadastrada'
                              ? 'Total de realizações cadastradas'
                              : 'Total de realizações cadastradas que você participa'}{' '}
                            <span className="text-base text-yellow leading-none font-semibold flex-1 text-right pl-2">
                              {resumePerCycle?.registered || '0'}
                            </span>
                          </li>
                          <li tabIndex={0} className="flex items-center justify-between text-white font-light text-xs leading-none mb-4 pb-4 border-b border-prussian-blue-2">
                            {tab === 'cadastrada'
                              ? 'Total de realizações validadas'
                              : 'Total de realizações validadas que você participa'}{' '}
                            <span className="text-base text-yellow leading-none font-semibold flex-1 text-right pl-2">
                              {resumePerCycle?.validated || '0'}
                            </span>
                          </li>
                          <li tabIndex={0} className="flex items-center justify-between text-white font-light text-xs leading-none">
                            {tab === 'cadastrada'
                              ? 'Total de realizações aguardando validação'
                              : 'Total de realizações aguardando validação que você participa'}{' '}
                            <span className="text-base text-yellow leading-none font-semibold flex-1 text-right pl-2">
                              {resumePerCycle?.waiting || '0'}
                            </span>
                          </li>
                        </ul>
                      </div>
                    )}
                  </>
                )}
              </Box>
            </div>

            {!!getFullCalendar && activeStageObj?._id !== PHASE_WITHOUT_REALIZATIONS_ID && (
              <div className="pt-3">
                <h2 tabIndex={0} className="text-xl text-white block mb-6 font-semibold">Calendário</h2>

                <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                  {loading ? (
                    <div className="grid grid-cols-1 gap-3">
                      <ArticlePlaceholder />
                    </div>
                  ) : (
                    <>
                      <div className="bg-maastricht-blue rounded-3xl p-8 space-y-4">
                        {/* <p className="block text-white leading-none font-normal text-base pb-2">Fase {activeStageObj?.title}</p> */}

                        <div className="font-thin">
                          {getFullCalendar.slice(0, calendarNumberOfElements).map((item, idx) => (
                            <p tabIndex={0} className={idx === 0 ? 'm-0' : `pt-2 mt-2 border-t border-prussian-blue-2`} key={item.title}>
                              <span className="text-yellow font-light">
                                {format(item.start, 'dd/MM')} a {format(subMinutes(item.end, 10), 'dd/MM')}:
                              </span>{' '}
                              {item.stage} - <span className="text-blue-light font-light">{item.period}</span>
                            </p>
                          ))}

                          {!!getFullCalendar && getFullCalendar?.length > (calendarElementsIndexOf as number) && (
                            <button
                              className="mt-4 mx-auto flex items-center text-grey-light justify-center lg:justify-start"
                              onClick={() =>
                                !calendarShowMore
                                  ? setCalendarNumberOfElements(calendarElementsIndexOf as number)
                                  : setCalendarNumberOfElements(calendarNumberOfElements + 5)
                              }
                            >
                              {!calendarShowMore ? (
                                <>
                                  <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                                  <span className="uppercase">Ver menos</span>
                                </>
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                  <span className="uppercase">Ver mais</span>
                                </>
                              )}
                            </button>
                          )}

                          {/* {activeStageObj?.type && activeStageObj?.type === 'month' && (
                              <p>
                                <span className="text-yellow font-light">
                                  {format(activeStageObj.date_start, 'dd/MM')} a{' '}
                                  {format(subMinutes(activeStageObj.date_finish, 10), 'dd/MM')}:
                                </span>{' '}
                                Cadastro
                              </p>
                            )}

                            {activeStageObj?.type &&
                              activeStageObj?.type === 'month' &&
                              activeStageObj?.date_evaluation_step2_start &&
                              activeStageObj?.date_evaluation_step2_finish && (
                                <p className="pt-4 border-t border-prussian-blue-2">
                                  <span className="text-yellow font-light">
                                    {format(activeStageObj?.date_evaluation_step2_start, 'dd/MM')} a{' '}
                                    {format(subMinutes(activeStageObj?.date_evaluation_step2_finish, 10), 'dd/MM')}:
                                  </span>{' '}
                                  Validação (Líderes imediatos)
                                </p>
                              )}

                            {activeStageObj?.type &&
                              activeStageObj?.type === 'month' &&
                              activeStageObj?.date_evaluation_step3_start &&
                              activeStageObj?.date_evaluation_step3_finish && (
                                <p className="pt-4 border-t border-prussian-blue-2">
                                  <span className="text-yellow font-light">
                                    {format(activeStageObj?.date_evaluation_step3_start, 'dd/MM')} a{' '}
                                    {format(subMinutes(activeStageObj?.date_evaluation_step3_finish, 10), 'dd/MM')}:
                                  </span>{' '}
                                  Apreciação Nível 1
                                </p>
                              )}

                            {activeStageObj?.type &&
                              activeStageObj?.type === 'trimester' &&
                              activeStageObj?.date_evaluation_step4_start &&
                              activeStageObj?.date_evaluation_step4_finish && (
                                <p className="pt-4 border-t border-prussian-blue-2">
                                  <span className="text-yellow font-light">
                                    {format(activeStageObj?.date_evaluation_step4_start, 'dd/MM')} a{' '}
                                    {format(subMinutes(activeStageObj?.date_evaluation_step4_finish, 10), 'dd/MM')}:
                                  </span>{' '}
                                  {playerInfo.mad ? <>Premiação Nível 2</> : <>Apreciação Nível 2 e Prosseguir</>}
                                </p>
                              )}

                            {activeStageObj?.type &&
                              activeStageObj?.type === 'semester' &&
                              activeStageObj?.date_evaluation_step5_start &&
                              activeStageObj?.date_evaluation_step5_finish && (
                                <p className="pt-4 border-t border-prussian-blue-2">
                                  <span className="text-yellow font-light">
                                    {format(activeStageObj?.date_evaluation_step5_start, 'dd/MM')} a{' '}
                                    {format(subMinutes(activeStageObj?.date_evaluation_step5_finish, 10), 'dd/MM')}:
                                  </span>{' '}
                                  Apreciação Nível 3 (Gerentes Gerais UE e Diretores)
                                </p>
                              )} */}
                        </div>
                      </div>
                    </>
                  )}
                </Box>
              </div>
            )}

          </div>

          <div className="lg:w-[64.8%]">
            <h2 tabIndex={0} className="text-xl text-white block mb-6 font-semibold">
              Realizações Destaque {activeStageObj?.status === 'open' ? 'da fase atual' : 'de ' + activeStageObj?.title}
            </h2>

            <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px] space-y-6">
              {loading ? (
                <div className="grid grid-cols-1 gap-3">
                  <ArticlePlaceholder />
                </div>
              ) : (
                <>
                  {renderCreateTaskPerCycle()}
                  {renderTasksPerCycle()}
                </>
              )}
            </Box>

            <DeletedTasksSection
              state={resolveDeletedSection({ tab, stage: activeStageObj, loading, result: deletedTasks })}
              items={deletedTasks?.items ?? []}
              owner={deletedOwner}
            />
          </div>
        </div>
      </div>

      {!!showModal && (
        <ModalChangeIndicator
          callback={e => {
            setShowModal(undefined);
            if (e) {
              loadData();
              setLoading(true);
            }
          }}
          id={showModal.id}
          owner={showModal.owner}
        />
      )}

      {typeof onOpenModalSendMessage === 'object' && (
        <ModalSendMessage
          managerId={onOpenModalSendMessage?.managerId}
          taskTitle={onOpenModalSendMessage?.taskTitle}
          managerName={onOpenModalSendMessage?.managerName}
          participantCount={onOpenModalSendMessage?.participantCount}
          onClose={() => setOnOpenModalSendMessage(false)}
        />
      )}
      <Outlet />
    </>
  );
}
